export default {
  disabled: false
};


//////////////////
// WEBPACK FOOTER
// ../~/react-transition-group/esm/config.js
// module id = 1319
// module chunks = 121